import { type UUID } from '~/types/common';

import { type CompaniesQueryParams } from './useQueryCompanies';
import { type EmployeesOfCompanyPayload } from './useQueryEmployeesOfCompany';

/**
 * Query key factory for company-related queries.
 */
export const queryKeysCompany = {
  base: () => 'companies' as const,
  get: (companyId: UUID) =>
    [queryKeysCompany.base(), 'detail', { companyId }] as const,
  getAll: (queryParams: Partial<CompaniesQueryParams>) =>
    [queryKeysCompany.base(), 'list', queryParams] as const,
  getAllInfinite: (queryParams: Partial<CompaniesQueryParams>) =>
    [queryKeysCompany.base(), 'list', 'infinite', queryParams] as const,
  getAllLegacy: () => [queryKeysCompany.base(), 'list', 'LEGACY'] as const,
  getAllowedBulk: (companyId: UUID) =>
    [queryKeysCompany.base(), 'bulk', 'allowed', { companyId }] as const,
  getAutoApproveDlnPositions: (companyId: UUID) =>
    [
      queryKeysCompany.base(),
      'auto-approve-dln-positions',
      { companyId },
    ] as const,
  getDlnToInvoice: (companyId: UUID) =>
    [queryKeysCompany.base(), 'dln-to-invoice', { companyId }] as const,
  getEmployees: (companyPayload: EmployeesOfCompanyPayload) =>
    [queryKeysCompany.base(), 'list', 'employees', { companyPayload }] as const,
  getInvoiceProtocol: (companyId: UUID) =>
    [queryKeysCompany.base(), 'invoice-protocol', { companyId }] as const,
  getInvoiceReceivers: (companyId: UUID | undefined) =>
    [queryKeysCompany.base(), 'invoice-receivers', { companyId }] as const,
  getInvoiceSendingSettings: (companyId: UUID) =>
    [
      queryKeysCompany.base(),
      'invoice-sending-settings',
      { companyId },
    ] as const,
  getLogo: (companyId: UUID) =>
    [queryKeysCompany.base(), 'logo', { companyId }] as const,
  getPublicInfo: (companyId: UUID) =>
    [queryKeysCompany.base(), 'publicInfo', { companyId }] as const,
  upsert: (companyId: UUID) =>
    [queryKeysCompany.base(), 'upsert', { companyId }] as const,
} as const;
